import { tap } from 'rxjs/operators';
import { AuthenticationService } from 'src/app/authentication.service';
import { LayoutService } from 'src/app/layout/layout.service';
import {
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { ActivatedRoute, Router } from '@angular/router';
import { AdmCompany } from '../../../models/adm-company';
import { MiscellaneousService } from '../miscellaneous.service';
import { AppInitService } from 'src/app/services/app-init.service';
import * as g from 'src/app/globals';
import { DOCUMENT } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Title } from '@angular/platform-browser';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.less'],
})
export class LoginComponent implements OnInit, OnDestroy {
  companies: AdmCompany[];
  isLoading = false;
  userName: string;
  password: string;
  companyDB: string;
  logoutOthersLoading = false;
  userFullName: string;

  returnUrl = '';

  @Input() hideTitle = false;
  @Input() isChangingCompany = false;
  @Input() hideButton = false;
  @Input() navigateAfter = true;
  @Output() submitCompleted = new EventEmitter();

  displayLandingPageLink = g.displayLandingPageLink;

  @ViewChild('userNameControl') userNameControl: ElementRef;
  @ViewChild('tplContent') logoutOthersContent: TemplateRef<any>;
  @ViewChild('tplFooter') logoutOthersFooter: TemplateRef<any>;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private message: NzMessageService,
    private router: Router,
    private miscellaneousService: MiscellaneousService,
    private appInitService: AppInitService,
    private layoutService: LayoutService,
    private authenticationService: AuthenticationService,
    private title: Title,
    private modal: NzModalService,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnDestroy(): void {
    this.title.setTitle(g.getTitleSuffix());
  }

  ngOnInit(): void {
    this.title.setTitle(
      this.layoutService.translate('Login to the employee portal')
    );
    this.loadCompanies();

    setTimeout(() => {
      this.userNameControl.nativeElement.focus();
      this.userNameControl.nativeElement.scrollIntoView(true);
    }, 1000);

    this.activatedRoute.params.subscribe((p) => {
      this.returnUrl = p.returnUrl;
    });
  }

  direct(type) {
    if (type === 'e') {
      localStorage.setItem('login-type', 'e');
      this.router.navigate(['/apps/authentication/external-login']);
    } else if (type === 'i') {
      localStorage.setItem('login-type', 'i');
      this.router.navigate(['/apps/authentication/login']);
    }
  }

  userNameChanged(): void {
    this.loadCompanies();
  }

  loadCompanies(): void {
    const userName = this.userName;
    this.miscellaneousService
      .getCompanies(userName)
      .subscribe((companies: AdmCompany[]) => {
        this.companies = companies;
        if (this.companies.length === 1) {
          this.companyDB = this.companies[0].companyDB;
        }
      });
  }

  submit(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.submitForm();
    }
  }

  submitForm(): void {
    const userName = this.userName;
    const password = this.password;
    const companyDB = this.companyDB;
    if (
      userName === '' ||
      password === '' ||
      companyDB === '' ||
      userName == null ||
      password == null ||
      companyDB == null
    ) {
      this.message.error(
        this.layoutService.translate(
          'Username, password and company are required.'
        )
      );
      return;
    }

    this.isLoading = true;

    this.miscellaneousService
      .createToken(userName, password, companyDB)
      .subscribe({
        next: (tokenResult: {
          Resault_Value: string;
          Has_Error: boolean;
          Error_Message: string;
        }) => {
          console.log('createToken executed' , tokenResult);
          if (tokenResult.Has_Error) {
            this.message.create('error', tokenResult.Error_Message);
            this.submitCompleted.emit(false);
            this.isLoading = false;
          }
          else if (
            tokenResult.Error_Message != null &&
            (tokenResult.Error_Message?.startsWith('K_N_E_') ||
              tokenResult.Error_Message.includes('_#_'))
          ) {
            this.router.navigate(['/apps/authentication/2FA'], {
              queryParams: {
                isExist: !tokenResult.Error_Message.startsWith('K_N_E_'),
              },
              state: {
                key: tokenResult.Error_Message,
                usercode: this.userName,
              },
            });
          } else {
            console.log('afterLogin will be executed');
            this.authenticationService.afterLogin(
              tokenResult.Resault_Value,
              this.navigateAfter,
              this.document,
              this.submitCompleted,
              this.appInitService,
              false,
              false,
              null,
              this.returnUrl
            );
            if (this.isChangingCompany) {
              window.location.reload();
            }
            this.authenticationService.initializeScripts.emit();
          }
        },
        error: (error: HttpErrorResponse) => {
          console.error('Login request failed', {
            status: error.status,
            statusText: error.statusText,
          });
          this.message.create('error', this.getLoginErrorMessage(error));
          this.submitCompleted.emit(false);
          this.isLoading = false;
        },
      });
  }

  private getLoginErrorMessage(error: HttpErrorResponse): string {
    const responseError = error.error;
    const errorMessage =
      responseError?.Error_Message ||
      responseError?.Message ||
      responseError?.message;

    if (errorMessage != null && errorMessage !== '') {
      return errorMessage;
    }

    return this.layoutService.translate(
      'Login failed. Please check your credentials and try again.'
    );
  }
  closeLougoutOthers() {
    window.location.reload();
  }
  logoutOthers() {
    this.miscellaneousService
      .logoutOthers()
      .pipe(
        tap((result) => {
          if (result.Has_Error) {
            this.message.create('error', result.Error_Message);
          } else {
            if (result.Resault_Value === 1) {
              this.router.navigate(['/apps']);
            }
          }
        })
      )
      .subscribe();
  }
}
